import Modal from './Modal'
import Plugin from './modal.plugin'

Modal.install = Plugin.install

export default Modal
